import React, { MutableRefObject, useState } from "react"
import classNames from "../../../utils/classNames"
import { currencySymbol } from "~/utils/currencySymbol"

const InputFieldWithCurrency = ({
  type,
  ref,
  label,
  name,
  id,
  value,
  defaultValue,
  placeholder,
  disabled,
  className,
  icon,
  onError,
  onChange,
  onBlur,
  onFocus,
  full,
  currency,
  hideCurrency,
  isChanged,
  readOnly,
  required,
  min,
  max,
  dataTestId,
}: {
  type?: string
  ref?: MutableRefObject<any>
  label?: string
  name?: string
  id?: string
  value?: any
  defaultValue?: any
  placeholder?: any
  disabled?: boolean
  className?: string
  icon?: any
  onError?: (err: any) => any
  onChange?: (e: any) => any
  onBlur?: (e: any) => any
  onFocus?: (e: any) => any
  full?: boolean
  currency?: string
  hideCurrency?: boolean
  isChanged?: boolean
  readOnly?: boolean
  required?: boolean
  min?: number
  max?: number
  dataTestId?: string
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let finalValue = e.target.value.trim()
    const validNumberRegex = /^-?\d*(\.\d*)?$/
    if (!validNumberRegex.test(finalValue)) {
      return
    }

    const parsedValue = parseFloat(finalValue)
    const mMax = max || Number.MAX_SAFE_INTEGER

    if (!isNaN(parsedValue)) {
      if (parsedValue > mMax) {
        finalValue = mMax.toString()
      }
    }

    onChange && onChange({ target: { name, value: finalValue } })
  }

  return (
    <div className={classNames(full && "w-full", className, disabled && "opacity-40")}>
      {label && (
        <label
          htmlFor="name"
          className={classNames(
            "block font-semibold text-md text-gray-900 mb-0.5",
            disabled ? "cursor-not-allowed text-gray-500" : "text-gray-900",
          )}
        >
          {label}
          {required && <span className="text-red-600 ml-0.5 relative top-[-0.125rem]">*</span>}
        </label>
      )}
      <div className="relative rounded-md shadow-sm flex items-center">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 top-0.5">
          {currency && <span className="text-gray-500 sm:text-sm">{currencySymbol(currency)}</span>}
        </div>
        <input
          ref={ref}
          data-testid={dataTestId}
          type={type || "number"}
          value={value}
          defaultValue={defaultValue}
          placeholder={placeholder}
          disabled={disabled}
          name={name}
          id={id || name}
          readOnly={readOnly}
          required={required}
          onError={onError}
          onChange={handleChange}
          onBlur={onBlur}
          onFocus={onFocus}
          className={classNames(
            "[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
            "block w-full rounded-md border-gray-300  pr-12 focus:border-green-700 focus:ring-green-700 focus:border",
            isChanged ? "bg-blue-50" : "bg-white",
            disabled ? "cursor-not-allowed border-gray-200 bg-gray-50 text-gray-500" : "",
            currency && "pl-6 !pr-1",
            hideCurrency ? "pr-6" : "pr-12 pl-6",
          )}
          aria-describedby="price-currency"
          step="any"
          min={min}
          max={max}
        />
        {!hideCurrency && (
          <div className="pointer-events-none absolute right-0 items-center pr-3 ">
            <span className="text-gray-500 sm:text-sm" id="price-currency">
              {currency?.toUpperCase() || "USD"}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

export default InputFieldWithCurrency
